
import React from 'react';

const News = () => {
  const cards = [
    {
      title: "Learn React",
      description: "React is a JavaScript library for building user interfaces.",
    },
    {
      title: "Master Tailwind",
      description: "Tailwind CSS is a utility-first CSS framework for rapid UI development.",
    },
    {
      title: "Build Amazing Apps",
      description: "Combine React and Tailwind CSS to create responsive, beautiful apps.",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-blue-600 text-center mb-8">
          Simple React & Tailwind CSS Example
        </h1>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {cards.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300"
            >
              <h2 className="text-xl font-semibold text-gray-800 mb-2">{card.title}</h2>
              <p className="text-gray-600">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default News;
